// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TextareaWrap_wrap__37SEJ","copy":"TextareaWrap_copy__227xb"};